import React from 'react'
import logo from '../image/logo.png'
import classes from '../styles/App.module.css'

const Logo = () => {
    return (
        <>
            <div className={`d-flex flex-row justify-content-center ${classes.logo}`}>
                <div>
                    <img src={logo} alt="logo" />
                </div>
                <div className="mx-3 align-self-center">
                    <h5>Mrh Rifat</h5>
                </div>
            </div>
        </>
    )
}

export default Logo